module.exports = __webpack_public_path__ + "img/lianxi2.859b6567.png";